import {
  API_FILTER_BY_STATUS,
  API_FILTER_BY_STATUS_RATE,
  API_FILTER_PACKAGE,
  API_GET_QNA_TICKET_ADMIN,
  API_GET_QNA_TICKET_BY_SUBJECT_ID,
  API_GET_TICKET_PACKAGE,
  API_SEARCH_PACKAGE,
  API_SEARCH_QNA_TICKET_BY_NAME,
  API_UPLOAD_FILE,
  CDN_URL,
} from '../config/data';

import dayjs from 'dayjs';
import toast, { NotifyType } from 'utils/toast';
import { StatusCodes } from 'http-status-codes';
import { clearAllStorage, getAuthenticator } from './localStorage';
import axios from 'axios';
import axiosInstance from '../axios/axiosInstance';
import { QA_TICKET_STATUS, ROLE_NAME, STATUS_RATE, TYPE_RATE } from './data';
import { getSessionByName } from './sessionStorage';
import { UserRole } from '../model/enum';

export const stringifyErrorMessage = (err: string | object | Array<any>) => {
  switch (Object.prototype.toString.call(err)) {
    case '[object Array]':
      // @ts-ignore
      return err?.join(', ');
    case '[object String]':
      return err;
    case '[object Object]':
      return err;
    default:
      return err?.toString();
  }
};

export const getErrorMessageFromResponse = (responseData: any, defaultMsg?: string | null): string => {
  // Object.prototype.toString.call(letiable)

  // console.log('getErrorMessageFromResponse', responseData)
  const arrayError =
    responseData?.response?.data?.data?.message ||
    responseData?.response?.data?.data?.Message ||
    responseData?.response?.data?.Data?.Message ||
    responseData?.response?.data?.message ||
    responseData?.response?.data?.Message ||
    responseData?.data?.errorMessage ||
    responseData?.data?.ErrorMessage ||
    responseData?.Data?.ErrorMessage ||
    responseData?.data?.message ||
    responseData?.data?.Message ||
    responseData?.Data?.Message ||
    responseData?.response?.data ||
    responseData?.response?.Data ||
    responseData?.message ||
    responseData?.Message ||
    responseData?.title ||
    responseData?.errorMessages ||
    responseData;

  // const message = arrayError.map((error) => {
  //   return stringifyErrorMessage(error);
  // }).find(c => !!c);
  return (
    stringifyErrorMessage(arrayError) ??
    defaultMsg ??
    'Đã có sự cố xảy ra, vui lòng thử lại sau hoặc liên hệ hỗ trợ để được trợ giúp!'
  );
};
// export const convertApiResponse = (response: any): IDataResponseCore<any> => {
//   const data = response?.data || response?.Data || response?.Data || response?.Data?.Data;
//   const success =
//     response?.success ||
//     response?.Success ||
//     response?.Data?.success ||
//     response?.Data?.Success ||
//     response?.Data?.Data?.Success;
//   return {
//     data: data,
//     message: getErrorMessageFromResponse(response, null) || null,
//     success: success,
//   };
// };

export const isPdf = (link: string) => {
  let regexCheckPdf = new RegExp('^.*.(pdf|PDF)$');
  return link.match(regexCheckPdf);
};
export const isWord = (link: string) => {
  let regexCheckDoc = new RegExp('^.*.(doc|docx|DOC|DOCX)$');
  return link.match(regexCheckDoc);
};
export const isPowerpoint = (link: string) => {
  let regexCheckPpt = new RegExp('^.*.(ppt|pptx|PPT|PPTX)$');
  return link.match(regexCheckPpt);
};
export const isVideo = (link: string) => {
  let regexCheckVideo = new RegExp('^.*.(webm|mp4|m4p|m4v|flv|mkv|vob|ogv|ogg|drc|avi|mpg|mpeg|mpe|mpv)$');
  return link.match(regexCheckVideo);
};

export const isImage = (link: string) => {
  let regexCheckImg = new RegExp('^.*.(jpg|JPG|JPEG|png|PNG|gif|GIF)$');
  return link.match(regexCheckImg);
};

export const isGifImage = (link: string) => {
  let regexCheckImg = new RegExp('^.*.(gif|GIF)$');
  return link.match(regexCheckImg);
};

export const isAudio = (link: string) => {
  let regexCheckAudio = new RegExp('^.*.(mp3|MP3|ogg|OGG|WAV|wav)$');
  return link.match(regexCheckAudio);
};

export const isZip = (link: string) => {
  let regexCheckZip = new RegExp('^.*.(zip|ZIP)$');
  return link.match(regexCheckZip);
};

export const getNameIcomImg = (link: string, isGroup = false) => {
  if (isGroup) {
    return 'nhom-hoc-lieu';
  } else if (isGifImage(link)) {
    return 'gif';
  } else if (isImage(link)) {
    return 'image';
  } else if (isAudio(link)) {
    return 'audio';
  } else {
    return 'play';
  }
};
// export const formatErrorQuestion = (data?: ResGetQuestion) => {
//   if (data?.childType !== TYPE_GROUP) {
//     if (data?.type === TYPE_FILL_INPUT_IMG || data?.type === TYPE_DOWN_ANSWER) {
//       const findData = data.answers.find((item:any) => !item.answerContent);
//       if (findData) {
//         return true;
//       } else {
//         return false;
//       }
//     }
//     if (data?.type === TYPE_RADIO) {
//       const findData = data.answers.find((item:any) => item.answerContent);
//       if (findData) {
//         return false;
//       } else {
//         return true;
//       }
//     }
//     if (data?.type === TYPE_SELECT) {
//       const findData = data.answers.find((item:any) => item.answerContent);
//       if (findData) {
//         return false;
//       } else {
//         return true;
//       }
//     }
//     if (data?.type === TYPE_FILL_BLANK) {
//       const answers = data.answers.filter((item:any) => !item.content.includes(BLANK_FILL_TXT));
//       const findData = answers.find((item:any) => !item.answerContent);
//       if (findData) {
//         return true;
//       } else {
//         return false;
//       }
//     }
//     if (data?.type === TYPE_FILL_BLANK) {
//       const answers = data.answers.filter((item:any) => !item.content.includes(BLANK_FILL_TXT));
//       const findData = answers.find((item:any) => !item.answerContent);
//       if (findData) {
//         return true;
//       } else {
//         return false;
//       }
//     }
//     if (data?.type === TYPE_MATH_COL) {
//       const dataNumber = data?.answers?.filter((item:any) => item.position.includes('left_'));
//       const findData = dataNumber.find((item:any) => !item.answerContent);
//       if (findData) {
//         return true;
//       } else {
//         return false;
//       }
//     }
//   } else {
//     const findData = data?.listQuestionChild?.find((item:any) => item.answers.find((f:any) => f.answerContent));
//     if (!findData) {
//       return true;
//     } else {
//       return false;
//     }
//   }
// };

export function convertHTML(str: string) {
  const symbols: any = {
    '<': '&lt;',
    '>': '&gt;',
  };
  for (const symbol in symbols) {
    if (str.indexOf(symbol) >= 0) {
      const newStr = str.replaceAll(symbol, symbols[symbol]);
      return newStr;
    }
  }
  return str;
}

export const replaceImageResize = (link: string, size: any) => {
  let result = CDN_URL + link.replace('Content//images', 'images');
  let extention = result.substring(result.length - 4, result.length);
  // console.log('Replace: ', result.substring(result.length - 4, result.length))
  return result.replace('Uploads', 'uploads').replace(extention, `_size_${size.width}_${size.height}${extention}`);
};

export const downloadFile = (url: string, name: string) => {
  // URL của file bạn muốn tải xuống
  const fileUrl = url;

  // Tên file mà bạn muốn lưu
  const fileName = 'name'; // Đổi tên file và phần mở rộng tương ứng

  // Tạo một yêu cầu HTTP GET để tải xuống file
  fetch(fileUrl)
    .then((response) => response.blob())
    .then((blob) => {
      // Tạo một đường dẫn tạm thời đến file blob
      const blobUrl = window.URL.createObjectURL(new Blob([blob]));

      // Tạo một thẻ a ẩn để thực hiện tải xuống
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;

      // Kích hoạt sự kiện click trên thẻ a để bắt đầu tải xuống
      link.click();

      // Xóa đường dẫn tạm thời khi đã tải xuống xong
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((error) => {
      console.error('Lỗi khi tải xuống file:', error);
    });
};
export const paginate = (array: any[], page_size: number, page_number: number) => {
  return array.slice((page_number - 1) * page_size, page_number * page_size);
};
export const formatDatePicker = (format: string, date?: string) => {
  if (date) {
    return dayjs(date).format(format);
  }
  return '';
};
export const replaceUrl = (url: string) => {
  if (url.includes('thu-vien')) {
    return url.replace('thu-vien', 'thu-vien-so');
  }
  return url;
};

export function convertDateTime(ngayThang: string) {
  // Chuyển đổi ngày tháng thành đối tượng Date
  let ngay = new Date(ngayThang);

  // Lấy giờ và phút
  let gio: any = ngay.getHours();
  let phut: any = ngay.getMinutes();

  // Chèn số 0 đằng trước nếu giờ hoặc phút nhỏ hơn 10
  gio = gio < 10 ? '0' + gio : gio;
  phut = phut < 10 ? '0' + phut : phut;

  // Lấy ngày, tháng, năm
  let ngayThangNam = ngay.getDate() + '/' + (ngay.getMonth() + 1) + '/' + ngay.getFullYear();

  // Tạo định dạng cuối cùng
  let ketQua = gio + ':' + phut + ' ' + ngayThangNam;

  return ketQua;
}

export function readFromSessionStorage(key: string): any {
  const value = sessionStorage.getItem(key);
  return value ? JSON.parse(value) : null;
}

export function spitDateTime(timeString: string) {
  let dateTime = new Date(timeString);

  // Lấy giờ và phút
  let hour: any = dateTime.getHours();
  let minute: any = dateTime.getMinutes();

  // Định dạng lại giờ và phút nếu cần
  hour = (hour < 10 ? '0' : '') + hour;
  minute = (minute < 10 ? '0' : '') + minute;

  // Lấy ngày, tháng và năm
  let day: any = dateTime.getDate();
  let month: any = dateTime.getMonth() + 1; // Tháng trong JavaScript bắt đầu từ 0
  let year = dateTime.getFullYear();

  // Định dạng lại ngày và tháng nếu cần
  day = (day < 10 ? '0' : '') + day;
  month = (month < 10 ? '0' : '') + month;

  // Hiển thị kết quả
  return { time: hour + ':' + minute, date: day + '/' + month + '/' + year };
}

export function mergeDateTime(timeString: string, dateString: string) {
  // Tách giờ và phút từ chuỗi thời gian
  let [hour, minute] = timeString.split(':');

  // Tách ngày, tháng và năm từ chuỗi ngày
  let [day, month, year] = dateString.split('/');

  // Tạo một đối tượng Date mới
  let dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute));

  // Chuyển đổi đối tượng Date thành chuỗi ISO 8601
  let isoString = dateObj.toISOString();

  return isoString;
}

export const convertSize = (inputBytes: number) => {
  if (inputBytes < 1024) {
    return inputBytes + ' bytes';
  } else if (inputBytes < 1024 * 1024) {
    return (inputBytes / 1024).toFixed(2) + ' KB';
  } else if (inputBytes < 1024 * 1024 * 1024) {
    return (inputBytes / (1024 * 1024)).toFixed(2) + ' MB';
  } else {
    return (inputBytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
  }
};

export const getFileNameFromUrl = (url: string) => {
  const fileName = url.split('/').pop() || 'unknown';
  return fileName;
};

export const getTypeFile = (typeFile: string) => {
  if (typeFile.includes('pdf')) return 'pdf';
  if (typeFile.includes('word')) return 'word';
  if (typeFile.includes('spreadsheetml')) return 'excel'; // Includes both xls and xlsx
  if (typeFile.includes('presentationml')) return 'powerpoint'; // Includes both ppt and pptx
  if (typeFile.includes('image')) return 'image';
  return 'other';
};

export const getFileIcon = (typeFile: string) => {
  const type = getTypeFile(typeFile);
  if (type === 'pdf') return '/assets/images/pdf_icon.png';
  if (type.includes('word')) return '/assets/images/word_icon.png';
  if (type.includes('excel')) return '/assets/images/excel_icon.png';
  if (type.includes('powerpoint')) return '/assets/images/powerpoint_icon.png';
  return '/assets/images/file_icon.png';
};

export const formatFileSize = (size: number) => {
  if (size < 1024) return `${size} B`;
  else if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  else if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  else return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
};

export const isValid = (object: any) => {
  if (object === null || object === undefined) return false;
  return true;
};

export const endSession = () => {
  if (isValid(getAuthenticator())) {
    toast(NotifyType.INFO, 'Phiên làm việc đã hết hạn!');
    setTimeout(() => {
      window.location.href = '/';
    }, 1000);
  } else {
    toast(NotifyType.INFO, 'Vui lòng đăng nhập!');
  }

  clearAllStorage();
};

export const fetchApiGet = async (apiUrl: string, accessToken?: string): Promise<unknown | null> => {
  try {
    const token = isValid(getAuthenticator()) ? getAuthenticator() : accessToken;

    const response = await axiosInstance.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === StatusCodes.CREATED && (response.data === undefined || response.data === '')) {
      return StatusCodes.CREATED;
    }

    return response.data;
  } catch (error) {
    return null;
  }
};

export const fetchApiDelete = async (apiUrl: string, accessToken?: string): Promise<unknown | null> => {
  try {
    const token = isValid(getAuthenticator()) ? getAuthenticator() : accessToken;

    const response = await axiosInstance.delete(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === StatusCodes.CREATED && (response.data === undefined || response.data === '')) {
      return StatusCodes.CREATED;
    }

    return response.data;
  } catch (error) {
    return null;
  }
};

export const fetchApiPost = async (apiUrl: string, postData: any, contentType: string): Promise<unknown> => {
  try {
    const response = await axiosInstance.post(apiUrl, postData, {
      headers: {
        'Content-Type': contentType,
      },
    });
    if (response.status === StatusCodes.CREATED && (response.data === undefined || response.data === '')) {
      return StatusCodes.CREATED;
    }
    return response.data;
  } catch (error) {
    return null;
  }
};

export const fetchApiPut = async (apiUrl: string, postData: any, contentType: string): Promise<unknown> => {
  try {
    const response = await axiosInstance.put(apiUrl, postData, {
      headers: {
        'Content-Type': contentType,
      },
    });
    if (response.status === StatusCodes.CREATED && (response.data === undefined || response.data === '')) {
      return StatusCodes.CREATED;
    }
    return response.data;
  } catch (error) {
    return null;
  }
};

export const fetchDownloadFile = async (url: string | undefined) => {
  if (url === undefined) {
    toast(NotifyType.WARNING, 'Có lỗi xảy ra');
    return;
  }
  try {
    await axiosInstance.get(url);
  } catch (error) {
    console.error('There was a problem with your fetch operation:', error);
  }
};

export const fetchApiUploadFile = async (postData: FormData): Promise<unknown> => {
  try {
    console.log(postData);
    const response = await axiosInstance.post(API_UPLOAD_FILE, postData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    let statusResponse = null;

    if (axios.isAxiosError(error)) {
      statusResponse = error.response?.status;

      if (statusResponse === StatusCodes.INTERNAL_SERVER_ERROR) {
        toast(NotifyType.WARNING, 'Vui lòng tải file dưới 50M!');
        return null;
      }
    }
    return null;
  }
};

export function convertTime(totalSeconds: any) {
  const minutes = Math.floor(totalSeconds / 60); // Tính số phút
  const seconds = totalSeconds % 60; // Tính số giây còn lại
  return `${minutes} phút ${seconds} giây`; // Trả về chuỗi định dạng
}

export const getUrlPage = (api: string, page: number, size: number) => {
  const hasQueryParams = api.includes('?');
  const separator = hasQueryParams ? '&' : '?';
  const url = `${api}${separator}page=${page - 1 >= 0 ? page - 1 : 0}&size=${size}`;
  return url;
};

export const getStatus = (status: any) => {
  if (status === QA_TICKET_STATUS.OPEN) return 'Mới';
  else if (status === QA_TICKET_STATUS.PROCESS) return 'Đang xử lý';
  else if (status === QA_TICKET_STATUS.REPORT) return 'Report';
  else return 'Kết thúc';
};

export const getQaRate = (rates: any) => {
  if (rates === undefined) return undefined;
  rates.sort((a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
  for (let i = rates?.length - 1; i >= 0; i--) {
    if (rates[i].typeRate === TYPE_RATE.RATE) {
      return rates[i];
    }
  }
  return undefined;
};

export const getQaReport = (rates: any) => {
  if (rates === undefined) return undefined;
  rates.sort((a: any, b: any) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime());
  for (let i = rates?.length - 1; i >= 0; i--) {
    if (rates[i].typeRate === TYPE_RATE.REPORT) {
      return rates[i];
    }
  }
  return undefined;
};

export const getStatusRate = (ticket: any) => {
  if (ticket === undefined || ticket === null) return;
  if (ticket?.status === QA_TICKET_STATUS.CLOSE) {
    const rate = getQaRate(ticket?.rates);
    if (rate !== undefined) return rate?.status === STATUS_RATE.GOOD ? 'Hài lòng' : 'Không hài lòng';
  }
  if (ticket?.status === QA_TICKET_STATUS.REPORT) {
    return 'Không hài lòng';
  }
};

export const getApiFilter = (subjectId: string) => {
  let url = '';
  let typeFilter = '',
    value = '';
  console.log(subjectId);
  const paramsArray = subjectId.includes('&') ? subjectId.split('&') : undefined;
  if (paramsArray !== undefined && paramsArray.length > 1) {
    typeFilter = paramsArray[0];
    value = paramsArray[1];
    if (typeFilter === 'status') {
      url = `${API_FILTER_BY_STATUS}${value}`;
    } else if (typeFilter === 'subject') {
      url = `${API_GET_QNA_TICKET_BY_SUBJECT_ID}${value}`;
    } else if (typeFilter === 'status-rate') {
      url = `${API_FILTER_BY_STATUS_RATE}${value?.toUpperCase()}`;
    } else if (typeFilter === 'search') {
      url = `${API_SEARCH_QNA_TICKET_BY_NAME}${value?.toLowerCase()}`;
    }
  } else if (paramsArray === undefined && isValid(subjectId)) {
    if (subjectId === 'all') {
      url = API_GET_QNA_TICKET_ADMIN;
    } else {
      url = `${API_GET_QNA_TICKET_BY_SUBJECT_ID}${subjectId}`;
    }
  }
  console.log('url: ', url);
  return url;
};

export const getApiFilterPackage = (typeTicket: string) => {
  let url = '';
  let typeFilter = '',
    value = '';
  console.log(typeTicket);
  const paramsArray = typeTicket.includes('&') ? typeTicket.split('&') : undefined;
  if (paramsArray !== undefined && paramsArray.length > 1) {
    typeFilter = paramsArray[0];
    value = paramsArray[1];
    if (typeFilter === 'typePackage') {
      url = `${API_FILTER_PACKAGE}?typeFilter=typePackage&value=${value}&typeTicket=${getSessionByName('typeTicket')}`;
    } else if (typeFilter === 'search') {
      url = `${API_SEARCH_PACKAGE}${value}?typeTicket=${getSessionByName('typeTicket')}`;
    }
  } else if (paramsArray === undefined && isValid(typeTicket)) {
    url = `${API_GET_TICKET_PACKAGE}${typeTicket?.toUpperCase()}`;
  }
  console.log(url);
  return url;
};

export const isGroupCtv = (role?: UserRole) => {
  return role === ROLE_NAME.ROLE_TEACHER || role === ROLE_NAME.ROLE_CTV || role === ROLE_NAME.ROLE_EXPERT;
};
